var initTabs = function initTabs() {
  var allTabsButtons = document.querySelectorAll('.tabs-js-button');
  allTabsButtons.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var id = e.target.dataset.id;
      var tabs = item.closest('.tabs-js').querySelectorAll('.tabs-js-content');
      var tabsTitles = item.closest('.tabs-js').querySelectorAll('.tabs-js-title');
      var tabsButtons = item.closest('.tabs-js').querySelectorAll('.tabs-js-button');
      tabsButtons.forEach(function (button) {
        if (button === e.target) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
      tabs.forEach(function (tab) {
        if (tab.id === id) {
          tab.dataset.show = true;
        } else {
          tab.dataset.show = false;
        }
      });
      tabsTitles.forEach(function (tabTitle) {
        if (tabTitle.dataset.titleId === id) {
          tabTitle.dataset.show = true;
        } else {
          tabTitle.dataset.show = false;
        }
      });
    });
  });
};
export { initTabs };